document.addEventListener('click', function (event) {
  const alert = event.target.closest('.alert')
  if (alert) {
    alert.remove()
  }
})
